import TemplateView from '../../../../TemplateView'
import {connect} from '../../../../redux/utils'
import {isTZGEnabled, isUGREnabled} from '../../../../features/selectors'
import {isOlVersion, isDemoVersion} from '../../../../constants'
import {isPossibleToCreateUsers} from '../../common/selectors'
import ManageGroupsList from "./ManageGroupsList";
import ManageGroupsButton from './ManageGroupsButton'
import AnimatedDialogWrapper from '../../../../util/AnimatedDialogWrapper'
import $ from "jquery";
import Button from "../../../../components/Button";
import messageResource from "../../../../messageResource";

export class ManagementButtonsContainer extends TemplateView {
    constructor({
        onManageUserDepartmentsClick = () => {},
        onManageTimeZoneGroupsClick = () => {},
        onAddNewUserClick = () => {},
        onBulkInvitationClick = () => {},
    }) {
        super(null)

        this.state = {
            isUGREnabled: false,
            isTZGEnabled: false,
            isPossibleToCreateUsers: false,
        }

        this.callbacks = {
            onManageUserDepartmentsClick,
            onManageTimeZoneGroupsClick,
            onAddNewUserClick,
            onBulkInvitationClick,
        }

        this.onStateChanged(() => {
            this.manageGroupsButton.setState({
                isUGREnabled: this.state.isUGREnabled,
                isTZGEnabled: this.state.isTZGEnabled,
            })

            this.manageGroupsButton.toggle(this.state.isUGREnabled || this.state.isTZGEnabled)
        })

        this.onStatePropertyChanged('isPossibleToCreateUsers', () => {
            this.addNewUserButton.setState({
                disabled: !this.state.isPossibleToCreateUsers
            })

            if (this.inviteUsersButton) {
                this.inviteUsersButton.setState({
                    disabled: !this.state.isPossibleToCreateUsers
                })
            }
        })

        this._handleManageGroupsButtonClick = this._handleManageGroupsButtonClick.bind(this)
    }


    templateHtml() {
        return '<div class="userList_container_managementButtonsContainer">' +
               '  <div class="manageGroups"></div>' +
               '</div>'
    }

    afterRender() {
        this.manageGroupsButton = new ManageGroupsButton({
            onButtonClick: this._handleManageGroupsButtonClick
        }).init(this.$el)
        this.manageGroupsButton.hide()

        this.manageGroupsDialog = new AnimatedDialogWrapper(null, {
            className: 'userList_manageButtons_component_manageGroupsList',
            toggleMode: true, // TODO not working :(
            dialog: new ManageGroupsList({
                departmentsOnClick: () => {
                    this.manageGroupsDialog.hide()
                    this.callbacks.onManageUserDepartmentsClick()
                },
                timeZoneOnClick: () => {
                    this.manageGroupsDialog.hide()
                    this.callbacks.onManageTimeZoneGroupsClick()
                },
            }),
            autoPosition: true,
        }).init($('body'))

        this.addNewUserButton = new Button({
            label: messageResource.getMessage('userlist.add_new_user'),
            withPlusIcon: true,
            onClickCb: this.callbacks.onAddNewUserClick
        }).init(this.$el)

        if (isOlVersion || isDemoVersion) {
            this.inviteUsersButton = new Button({
                label: messageResource.getMessage('userlist.bulk_invitations'),
                additionalClass: 'addSeveralUsersButton',
                onClickCb: this.callbacks.onBulkInvitationClick,
            }).init(this.$el)
        }
    }

    _handleManageGroupsButtonClick = () => {
        if (this.state.isUGREnabled && this.state.isTZGEnabled) {
            this.manageGroupsDialog.showAt(
                this.manageGroupsButton.getEl(),
                {
                    my: 'left top',
                    at: 'left bottom',
                })
        } else if (this.state.isUGREnabled) {
            this.callbacks.onManageUserDepartmentsClick()
        } else if (this.state.isTZGEnabled) {
            this.callbacks.onManageTimeZoneGroupsClick()
        }
    }
}

export default connect((state) => {
    return {
        isUGREnabled: isUGREnabled(state),
        isTZGEnabled: isTZGEnabled(state),
        isPossibleToCreateUsers: isPossibleToCreateUsers(state),
    }
})(ManagementButtonsContainer)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/ManagementButtonsContainer.js